import React from "react";

export interface isMobile {
    isMobile: boolean
}

export const AppContext = React.createContext<isMobile | undefined>(undefined);

export function UseAppContext() {
    const screen = React.useContext(AppContext);

    if (screen === undefined) {
        throw new Error("Unable to load screen size data.");
    }

    return screen;
}